/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  RoutePlanFeedbackAccessDTO,
  RoutePlanFeedbackAnswerRequestDTO,
  RoutePlanFeedbackDismissRequestDTO,
  RoutePlanFeedbackNextParams,
  RoutePlanFeedbackNextResponseDTO,
  RoutePlanFeedbackPackageDTO,
  RoutePlanFeedbackPackageParams,
  RoutePlanFeedbackPromptResponseDTO,
  RoutePlanFeedbackPromptShownRequestDTO,
  RoutePlanFeedbackResultsDTO,
  RoutePlanFeedbackResultsParams,
  RoutePlanFeedbackTriggerRequestDTO,
  RoutePlanFeedbackTriggerSampleStatusParams,
  RoutePlanFeedbackTriggerStatusDTO,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useRoutePlanFeedbackAccessHook = () => {
  const routePlanFeedbackAccess =
    useCustomInstance<RoutePlanFeedbackAccessDTO>();

  return useCallback(
    (signal?: AbortSignal) => {
      return routePlanFeedbackAccess({
        url: `/api/RoutePlanFeedback/Access`,
        method: 'GET',
        signal,
      });
    },
    [routePlanFeedbackAccess]
  );
};

export const getRoutePlanFeedbackAccessQueryKey = () => {
  return [`/api/RoutePlanFeedback/Access`] as const;
};

export const useRoutePlanFeedbackAccessQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useRoutePlanFeedbackAccessHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackAccessHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRoutePlanFeedbackAccessQueryKey();

  const routePlanFeedbackAccess = useRoutePlanFeedbackAccessHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackAccessHook>>>
  > = ({ signal }) => routePlanFeedbackAccess(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackAccessHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RoutePlanFeedbackAccessQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackAccessHook>>>
>;
export type RoutePlanFeedbackAccessQueryError = unknown;

export const useRoutePlanFeedbackAccess = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useRoutePlanFeedbackAccessHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackAccessHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useRoutePlanFeedbackAccessQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useRoutePlanFeedbackPromptHook = () => {
  const routePlanFeedbackPrompt =
    useCustomInstance<RoutePlanFeedbackPromptResponseDTO>();

  return useCallback(
    (signal?: AbortSignal) => {
      return routePlanFeedbackPrompt({
        url: `/api/RoutePlanFeedback/Prompt`,
        method: 'GET',
        signal,
      });
    },
    [routePlanFeedbackPrompt]
  );
};

export const getRoutePlanFeedbackPromptQueryKey = () => {
  return [`/api/RoutePlanFeedback/Prompt`] as const;
};

export const useRoutePlanFeedbackPromptQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useRoutePlanFeedbackPromptHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPromptHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRoutePlanFeedbackPromptQueryKey();

  const routePlanFeedbackPrompt = useRoutePlanFeedbackPromptHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPromptHook>>>
  > = ({ signal }) => routePlanFeedbackPrompt(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPromptHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RoutePlanFeedbackPromptQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPromptHook>>>
>;
export type RoutePlanFeedbackPromptQueryError = unknown;

export const useRoutePlanFeedbackPrompt = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useRoutePlanFeedbackPromptHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPromptHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useRoutePlanFeedbackPromptQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useRoutePlanFeedbackDismissPromptHook = () => {
  const routePlanFeedbackDismissPrompt = useCustomInstance<boolean>();

  return useCallback(
    (
      routePlanFeedbackDismissRequestDTO: RoutePlanFeedbackDismissRequestDTO
    ) => {
      return routePlanFeedbackDismissPrompt({
        url: `/api/RoutePlanFeedback/DismissPrompt`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: routePlanFeedbackDismissRequestDTO,
      });
    },
    [routePlanFeedbackDismissPrompt]
  );
};

export const useRoutePlanFeedbackDismissPromptMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanFeedbackDismissPromptHook>>
    >,
    TError,
    { data: RoutePlanFeedbackDismissRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackDismissPromptHook>>>,
  TError,
  { data: RoutePlanFeedbackDismissRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanFeedbackDismissPrompt =
    useRoutePlanFeedbackDismissPromptHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanFeedbackDismissPromptHook>>
    >,
    { data: RoutePlanFeedbackDismissRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanFeedbackDismissPrompt(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanFeedbackDismissPromptMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackDismissPromptHook>>>
>;
export type RoutePlanFeedbackDismissPromptMutationBody =
  RoutePlanFeedbackDismissRequestDTO;
export type RoutePlanFeedbackDismissPromptMutationError = unknown;

export const useRoutePlanFeedbackDismissPrompt = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanFeedbackDismissPromptHook>>
    >,
    TError,
    { data: RoutePlanFeedbackDismissRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackDismissPromptHook>>>,
  TError,
  { data: RoutePlanFeedbackDismissRequestDTO },
  TContext
> => {
  const mutationOptions =
    useRoutePlanFeedbackDismissPromptMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useRoutePlanFeedbackPromptShownHook = () => {
  const routePlanFeedbackPromptShown = useCustomInstance<boolean>();

  return useCallback(
    (
      routePlanFeedbackPromptShownRequestDTO: RoutePlanFeedbackPromptShownRequestDTO
    ) => {
      return routePlanFeedbackPromptShown({
        url: `/api/RoutePlanFeedback/PromptShown`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: routePlanFeedbackPromptShownRequestDTO,
      });
    },
    [routePlanFeedbackPromptShown]
  );
};

export const useRoutePlanFeedbackPromptShownMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPromptShownHook>>>,
    TError,
    { data: RoutePlanFeedbackPromptShownRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPromptShownHook>>>,
  TError,
  { data: RoutePlanFeedbackPromptShownRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanFeedbackPromptShown = useRoutePlanFeedbackPromptShownHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPromptShownHook>>>,
    { data: RoutePlanFeedbackPromptShownRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanFeedbackPromptShown(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanFeedbackPromptShownMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPromptShownHook>>>
>;
export type RoutePlanFeedbackPromptShownMutationBody =
  RoutePlanFeedbackPromptShownRequestDTO;
export type RoutePlanFeedbackPromptShownMutationError = unknown;

export const useRoutePlanFeedbackPromptShown = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPromptShownHook>>>,
    TError,
    { data: RoutePlanFeedbackPromptShownRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPromptShownHook>>>,
  TError,
  { data: RoutePlanFeedbackPromptShownRequestDTO },
  TContext
> => {
  const mutationOptions =
    useRoutePlanFeedbackPromptShownMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useRoutePlanFeedbackNextHook = () => {
  const routePlanFeedbackNext =
    useCustomInstance<RoutePlanFeedbackNextResponseDTO>();

  return useCallback(
    (params?: RoutePlanFeedbackNextParams, signal?: AbortSignal) => {
      return routePlanFeedbackNext({
        url: `/api/RoutePlanFeedback/Next`,
        method: 'GET',
        params,
        signal,
      });
    },
    [routePlanFeedbackNext]
  );
};

export const getRoutePlanFeedbackNextQueryKey = (
  params?: RoutePlanFeedbackNextParams
) => {
  return [`/api/RoutePlanFeedback/Next`, ...(params ? [params] : [])] as const;
};

export const useRoutePlanFeedbackNextQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackNextHook>>>,
  TError = unknown,
>(
  params?: RoutePlanFeedbackNextParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackNextHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRoutePlanFeedbackNextQueryKey(params);

  const routePlanFeedbackNext = useRoutePlanFeedbackNextHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackNextHook>>>
  > = ({ signal }) => routePlanFeedbackNext(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackNextHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RoutePlanFeedbackNextQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackNextHook>>>
>;
export type RoutePlanFeedbackNextQueryError = unknown;

export const useRoutePlanFeedbackNext = <
  TData = Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackNextHook>>>,
  TError = unknown,
>(
  params?: RoutePlanFeedbackNextParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackNextHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useRoutePlanFeedbackNextQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useRoutePlanFeedbackPackageHook = () => {
  const routePlanFeedbackPackage =
    useCustomInstance<RoutePlanFeedbackPackageDTO>();

  return useCallback(
    (params?: RoutePlanFeedbackPackageParams, signal?: AbortSignal) => {
      return routePlanFeedbackPackage({
        url: `/api/RoutePlanFeedback/Package`,
        method: 'GET',
        params,
        signal,
      });
    },
    [routePlanFeedbackPackage]
  );
};

export const getRoutePlanFeedbackPackageQueryKey = (
  params?: RoutePlanFeedbackPackageParams
) => {
  return [
    `/api/RoutePlanFeedback/Package`,
    ...(params ? [params] : []),
  ] as const;
};

export const useRoutePlanFeedbackPackageQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useRoutePlanFeedbackPackageHook>>
  >,
  TError = unknown,
>(
  params?: RoutePlanFeedbackPackageParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPackageHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRoutePlanFeedbackPackageQueryKey(params);

  const routePlanFeedbackPackage = useRoutePlanFeedbackPackageHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPackageHook>>>
  > = ({ signal }) => routePlanFeedbackPackage(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPackageHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RoutePlanFeedbackPackageQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPackageHook>>>
>;
export type RoutePlanFeedbackPackageQueryError = unknown;

export const useRoutePlanFeedbackPackage = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useRoutePlanFeedbackPackageHook>>
  >,
  TError = unknown,
>(
  params?: RoutePlanFeedbackPackageParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackPackageHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useRoutePlanFeedbackPackageQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useRoutePlanFeedbackAnswerHook = () => {
  const routePlanFeedbackAnswer = useCustomInstance<boolean>();

  return useCallback(
    (routePlanFeedbackAnswerRequestDTO: RoutePlanFeedbackAnswerRequestDTO) => {
      return routePlanFeedbackAnswer({
        url: `/api/RoutePlanFeedback/Answer`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: routePlanFeedbackAnswerRequestDTO,
      });
    },
    [routePlanFeedbackAnswer]
  );
};

export const useRoutePlanFeedbackAnswerMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackAnswerHook>>>,
    TError,
    { data: RoutePlanFeedbackAnswerRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackAnswerHook>>>,
  TError,
  { data: RoutePlanFeedbackAnswerRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanFeedbackAnswer = useRoutePlanFeedbackAnswerHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackAnswerHook>>>,
    { data: RoutePlanFeedbackAnswerRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanFeedbackAnswer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanFeedbackAnswerMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackAnswerHook>>>
>;
export type RoutePlanFeedbackAnswerMutationBody =
  RoutePlanFeedbackAnswerRequestDTO;
export type RoutePlanFeedbackAnswerMutationError = unknown;

export const useRoutePlanFeedbackAnswer = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackAnswerHook>>>,
    TError,
    { data: RoutePlanFeedbackAnswerRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackAnswerHook>>>,
  TError,
  { data: RoutePlanFeedbackAnswerRequestDTO },
  TContext
> => {
  const mutationOptions = useRoutePlanFeedbackAnswerMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useRoutePlanFeedbackTriggerSampleHook = () => {
  const routePlanFeedbackTriggerSample =
    useCustomInstance<RoutePlanFeedbackTriggerStatusDTO>();

  return useCallback(
    (
      routePlanFeedbackTriggerRequestDTO: RoutePlanFeedbackTriggerRequestDTO
    ) => {
      return routePlanFeedbackTriggerSample({
        url: `/api/RoutePlanFeedback/TriggerSample`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: routePlanFeedbackTriggerRequestDTO,
      });
    },
    [routePlanFeedbackTriggerSample]
  );
};

export const useRoutePlanFeedbackTriggerSampleMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanFeedbackTriggerSampleHook>>
    >,
    TError,
    { data: RoutePlanFeedbackTriggerRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackTriggerSampleHook>>>,
  TError,
  { data: RoutePlanFeedbackTriggerRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const routePlanFeedbackTriggerSample =
    useRoutePlanFeedbackTriggerSampleHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanFeedbackTriggerSampleHook>>
    >,
    { data: RoutePlanFeedbackTriggerRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return routePlanFeedbackTriggerSample(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RoutePlanFeedbackTriggerSampleMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackTriggerSampleHook>>>
>;
export type RoutePlanFeedbackTriggerSampleMutationBody =
  RoutePlanFeedbackTriggerRequestDTO;
export type RoutePlanFeedbackTriggerSampleMutationError = unknown;

export const useRoutePlanFeedbackTriggerSample = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanFeedbackTriggerSampleHook>>
    >,
    TError,
    { data: RoutePlanFeedbackTriggerRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackTriggerSampleHook>>>,
  TError,
  { data: RoutePlanFeedbackTriggerRequestDTO },
  TContext
> => {
  const mutationOptions =
    useRoutePlanFeedbackTriggerSampleMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useRoutePlanFeedbackTriggerSampleStatusHook = () => {
  const routePlanFeedbackTriggerSampleStatus =
    useCustomInstance<RoutePlanFeedbackTriggerStatusDTO>();

  return useCallback(
    (
      params?: RoutePlanFeedbackTriggerSampleStatusParams,
      signal?: AbortSignal
    ) => {
      return routePlanFeedbackTriggerSampleStatus({
        url: `/api/RoutePlanFeedback/TriggerSampleStatus`,
        method: 'GET',
        params,
        signal,
      });
    },
    [routePlanFeedbackTriggerSampleStatus]
  );
};

export const getRoutePlanFeedbackTriggerSampleStatusQueryKey = (
  params?: RoutePlanFeedbackTriggerSampleStatusParams
) => {
  return [
    `/api/RoutePlanFeedback/TriggerSampleStatus`,
    ...(params ? [params] : []),
  ] as const;
};

export const useRoutePlanFeedbackTriggerSampleStatusQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useRoutePlanFeedbackTriggerSampleStatusHook>>
  >,
  TError = unknown,
>(
  params?: RoutePlanFeedbackTriggerSampleStatusParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useRoutePlanFeedbackTriggerSampleStatusHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRoutePlanFeedbackTriggerSampleStatusQueryKey(params);

  const routePlanFeedbackTriggerSampleStatus =
    useRoutePlanFeedbackTriggerSampleStatusHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanFeedbackTriggerSampleStatusHook>>
    >
  > = ({ signal }) => routePlanFeedbackTriggerSampleStatus(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useRoutePlanFeedbackTriggerSampleStatusHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RoutePlanFeedbackTriggerSampleStatusQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useRoutePlanFeedbackTriggerSampleStatusHook>>
  >
>;
export type RoutePlanFeedbackTriggerSampleStatusQueryError = unknown;

export const useRoutePlanFeedbackTriggerSampleStatus = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useRoutePlanFeedbackTriggerSampleStatusHook>>
  >,
  TError = unknown,
>(
  params?: RoutePlanFeedbackTriggerSampleStatusParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useRoutePlanFeedbackTriggerSampleStatusHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useRoutePlanFeedbackTriggerSampleStatusQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useRoutePlanFeedbackResultsHook = () => {
  const routePlanFeedbackResults =
    useCustomInstance<RoutePlanFeedbackResultsDTO>();

  return useCallback(
    (params?: RoutePlanFeedbackResultsParams, signal?: AbortSignal) => {
      return routePlanFeedbackResults({
        url: `/api/RoutePlanFeedback/Results`,
        method: 'GET',
        params,
        signal,
      });
    },
    [routePlanFeedbackResults]
  );
};

export const getRoutePlanFeedbackResultsQueryKey = (
  params?: RoutePlanFeedbackResultsParams
) => {
  return [
    `/api/RoutePlanFeedback/Results`,
    ...(params ? [params] : []),
  ] as const;
};

export const useRoutePlanFeedbackResultsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useRoutePlanFeedbackResultsHook>>
  >,
  TError = unknown,
>(
  params?: RoutePlanFeedbackResultsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackResultsHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRoutePlanFeedbackResultsQueryKey(params);

  const routePlanFeedbackResults = useRoutePlanFeedbackResultsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackResultsHook>>>
  > = ({ signal }) => routePlanFeedbackResults(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackResultsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RoutePlanFeedbackResultsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackResultsHook>>>
>;
export type RoutePlanFeedbackResultsQueryError = unknown;

export const useRoutePlanFeedbackResults = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useRoutePlanFeedbackResultsHook>>
  >,
  TError = unknown,
>(
  params?: RoutePlanFeedbackResultsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useRoutePlanFeedbackResultsHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useRoutePlanFeedbackResultsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
